import { RIGHT_ALIGNED_LANGUAGES } from '../constants/languageConstants';

export const setDocumentDirection = (languageCode, direction) => {
    const dir = RIGHT_ALIGNED_LANGUAGES.includes(languageCode) && direction ? 'rtl' : 'ltr';
    document.documentElement.setAttribute('dir', dir);
};
